import React from 'react'
import styles from './Box.module.css'

const box =(props) => (
    <div className={styles.Box}>{props.children}</div>     
)

export default box